import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Clock } from "lucide-react";

export default function Timeline() {
  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/timeline")
      .then((r) => setDays(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-4 sm:p-6 space-y-5" data-testid="timeline-page">
      <header>
        <div className="text-xs font-mono uppercase tracking-wider text-blue-700">
          Timeline
        </div>
        <h1 className="font-display font-bold tracking-tight text-3xl">
          Activity over time
        </h1>
        <p className="text-slate-500 text-sm mt-2 max-w-2xl">
          Advertisements grouped by the day they were posted.
        </p>
      </header>

      {loading && <div className="text-sm text-slate-500">Loading…</div>}

      <div className="border-l-2 border-slate-200 pl-6 space-y-8">
        {days.map((d) => (
          <div key={d.date} className="relative" data-testid={`day-${d.date}`}>
            <span
              className="absolute -left-[31px] top-1 h-3 w-3 rounded-full bg-blue-600 border-2 border-white"
              aria-hidden
            />
            <div className="flex items-center gap-2 mb-2">
              <Clock className="h-4 w-4 text-slate-500" />
              <h2 className="font-display font-bold text-lg tracking-tight">
                {d.date}
              </h2>
              <span className="text-xs text-slate-500 font-mono">
                {d.ads.length} ad{d.ads.length === 1 ? "" : "s"}
              </span>
            </div>
            <div className="border border-slate-200 bg-white rounded-md divide-y divide-slate-100">
              {d.ads.map((a) => (
                <Link
                  key={a.id}
                  to={`/ads/${a.id}`}
                  data-testid={`timeline-ad-${a.id}`}
                  className="flex items-center justify-between px-4 py-2.5 hover:bg-slate-50"
                >
                  <div className="min-w-0">
                    <div className="text-sm truncate">{a.title}</div>
                    <div className="text-xs text-slate-500 font-mono truncate">
                      {a.locality || "Unknown"} · {(a.phones || []).join(" · ")}
                    </div>
                  </div>
                  <span className="text-xs text-slate-400">→</span>
                </Link>
              ))}
            </div>
          </div>
        ))}
        {!loading && days.length === 0 && (
          <div className="text-sm text-slate-500">No activity recorded yet.</div>
        )}
      </div>
    </div>
  );
}
